import { InformeCumplimiento } from '../informe/informe-cumplimiento';

/**
 * Filtros para el listado de informes enviados / preaprobados.
 * Va como body del POST /aprobar-rechazar-informe/buscar (patrón anti-enumeración).
 * Legacy: Sp_sgs_informes_no_aprobadosInputParameter.
 */
export interface BuscarInformesEnviadosRequest {
  orientacionServicio?: string | null;
  dniEmpresa?: string | null;
  dniProfesional?: string | null;

  /** Página 0-based. */
  pageNumber: number;
  pageSize: number;
}

/**
 * Payload de un informe seleccionado que se envía en el body de aprobar/rechazar.
 * IMPORTANTE: incluir TODOS los campos operativos que el UseCase necesita
 * (patrón anti-enumeración: no llamadas laterales al backend por ID).
 * Referencia: commit frontend 330df87f "Ajuste Endpoints ID".
 */
export interface InformeSeleccionadoPayload {
  nmconsecutivo: number;
  cdfuente?: string;
  cdpanoramas?: string;
  snparcial?: string;
  nmconsecutivoCumplimiento?: number;
  snrqcopiaaprobacion?: string;
  dscorreoasesor?: string;
  dscorreodistribuidor?: string;
  dsnombredistribuidor?: string;
  dsasesor?: string;
  dsbeneficiario?: string;
  dstarea?: string;
  dsproducto?: string;
}

export interface RechazarInformesRequest {
  cdcausaRechazo: number;
  dscausaRechazo?: string;
  dsobservaciones: string;
  informes: InformeSeleccionadoPayload[];
}

export interface AprobarInformesRequest {
  informes: InformeSeleccionadoPayload[];
}

export interface DetalleResultadoInforme {
  nmconsecutivoInforme: number;
  exito: boolean;
  mensaje: string;
}

export interface ResultadoOperacion {
  exito: boolean;
  mensaje: string;
  resultados: DetalleResultadoInforme[];
}

/**
 * Mapea un `InformeCumplimiento` de la tabla a un `InformeSeleccionadoPayload`
 * con SÓLO los campos operativos (evita enviar el objeto completo al backend).
 */
export function toInformePayload(informe: InformeCumplimiento): InformeSeleccionadoPayload {
  return {
    nmconsecutivo: informe.nmconsecutivoinforme!,
    cdfuente: informe.cdfuente,
    cdpanoramas: informe.cdpanoramas,
    snparcial: informe.snparcial,
    nmconsecutivoCumplimiento: informe.nmconsecutivocumplimiento,
    snrqcopiaaprobacion: informe.snrqcopiaaprobacion,
    dscorreoasesor: informe.dscorreoasesor,
    dscorreodistribuidor: informe.dscorreodistribuidor,
    dsnombredistribuidor: informe.dsnombredistribuidor,
    dsasesor: informe.dsasesor,
    dsbeneficiario: informe.dsbeneficiario,
    dstarea: informe.dstarea,
    dsproducto: informe.dsproducto,
  };
}
